import { Document, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import { priceFormat } from 'helper/common';
import { getDate } from 'helper/date';
import logo from './logo-blue-iranair.png';
const Invoice = ({ ticketData }) => {
  const styles = StyleSheet.create({
    Wrapper: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      padding: '16px',
      width: '100%',
      boxShadow: '0 3px 10px rgb(0 0 0 / 0.2)',
      position: 'relative',
    },
    Transaction: {
      width: '100%',
      borderRadius: '12px',
      padding: '12px',
      paddingHorizontal: ' 24px',
      boxShadow: '0 3px 10px rgb(0 0 0 / 0.2)',
      display: 'flex',
      justifyContent: 'space-between',
      maxWidth: '1498px',
      marginHorizontal: 'auto',
      marginBottom: '8px',
      flexDirection: 'column',
      // backgroundColor: ` ${ticketData?.transaction?.status === 'ok' ? '#60c08e52' : '#f8585863'}`,
      // color: ` ${ticketData?.transaction?.status === 'ok' ? '#60C08E' : '#F85858'}`,
    },
    Title: {
      padding: '12px',
    },
    Card: {
      borderRadius: '12px',
      padding: '12px',
      width: '100%',
      paddingHorizontal: '24px',
      backgroundColor: '#ffffff',
      border: '1px solid #bcc1d7',
      boxShadow: '0 3px 10px rgb(0 0 0 / 0.2)',
      display: 'flex',
      justifyContent: 'space-between',
      maxWidth: '1498px',
      marginHorizontal: 'auto',
      marginBottom: '8px',
    },
    BoxWrapper: {
      flexGrow: 1,
    },
    Row: {
      display: 'flex',
      alignItems: 'flex-start',
      flexDirection: 'row',
      justifyContent: 'space-between',

      // width: '100%',
      // display: 'flex',

      // flexWrap: 'wrap',

      // lineHeight: 1.5,
    },
    Box: {
      lineHeight: 'normal',
      display: 'flex',
      flexDirection: 'column',
    },
    Lable: {
      fontSize: '12px',
      color: '#bcc1d7',
    },
    Value: {
      fontSize: '10px',
      color: '#7a7a7a',
      //  display: "inline-block",
      marginTop: '4px',
    },
    container: {
      width: '220px',
      borderRadius: '5px',
      padding: '15px 12px',
      display: 'flex',
      flexDirection: 'column',
      gap: '15px',
      boxShadow: '0 3px 10px #44000000',
    },

    page: { fontSize: 11, paddingTop: 20, paddingLeft: 40, paddingRight: 40, lineHeight: 1.5, flexDirection: 'column' },

    spaceBetween: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      color: '#3E3E3E',
    },
  });
  const ptcBaceFar = () => {
    const ptcfareBreakdowns = ticketData?.bookData?.priceInfo?.ptcfareBreakdowns?.ptcfareBreakdown
      .map((items) =>
        items?.passengerFare.reduce((acc, curr) => {
          return acc + Number(curr.baseFare.amount);
        }, 0)
      )
      .reduce((ac, crr) => {
        return ac + crr;
      }, 0);
    return ptcfareBreakdowns;
  };
  const ptcTotalFar = () => {
    const ptcfareBreakdowns = ticketData?.bookData?.priceInfo?.ptcfareBreakdowns?.ptcfareBreakdown
      .map((items) =>
        items?.passengerFare.reduce((acc, curr) => {
          return acc + Number(curr.totalFare.amount);
        }, 0)
      )
      .reduce((ac, crr) => {
        return ac + crr;
      }, 0);
    return ptcfareBreakdowns;
  };
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.Wrapper}>
          {ticketData?.transaction ? (
            <View
              style={[
                styles.Transaction,
                { backgroundColor: `${ticketData.transaction.status === 'ok' ? '#60c08e52' : '#f8585863'}` },
                { color: `${ticketData.transaction.status === 'ok' ? '#60c08e' : '#f85858'}` },
              ]}
            >
              <Text>{ticketData.transaction.status === 'ok' ? 'transaction successful' : 'transaction failed'}</Text>
              <Text>
                PNR (reference number):
                {ticketData.transaction.systemTraceNo ? ticketData.transaction.systemTraceNo : '_'}
              </Text>
              <Text>
                Transaction amount : {ticketData.transaction.amount ? priceFormat(ticketData.transaction.amount) : '_'}{' '}
                IRR
              </Text>
            </View>
          ) : (
            ''
          )}
        </View>
        {ticketData?.bookData && (
          <>
            <Text style={styles.Title}>Passengers:</Text>
            <View style={styles.Card}>
              <View style={styles.BoxWrapper}>
                <View style={styles.Row}>
                  <View style={styles.Box}>
                    <Text style={styles.Lable}> Fullname:</Text>
                    <Text
                      style={styles.Value}
                    >{`${ticketData?.bookData?.contactPerson.personName.givenName[0]} ${ticketData?.bookData?.contactPerson.personName.surname}`}</Text>
                  </View>
                  {ticketData?.bookData?.travelerInfo.airTraveler.map((traveler) => {
                    return (
                      <>
                        <View style={styles.Box}>
                          <Text style={styles.Lable}> Date of birth: </Text>
                          <Text style={styles.Value}>{getDate(traveler.birthDate)}</Text>
                        </View>
                        <View style={styles.Box}>
                          <Text style={styles.Lable}> Passport Number: </Text>
                          <Text style={styles.Value}>{traveler.document[0].docID}</Text>
                        </View>
                      </>
                    );
                  })}
                </View>
              </View>
            </View>
          </>
        )}
        {ticketData?.bookData && (
          <>
            <Text style={styles.Title}>flight info: {`PNR : ${ticketData?.awardticket.PNR}`}</Text>
            <View>
              {ticketData?.bookData?.airItinerary?.originDestinationOptions?.originDestinationOption[0].flightSegment?.map(
                (traveler) => {
                  return (
                    <>
                      <View style={styles.Card}>
                        <View style={styles.BoxWrapper}>
                          <View style={styles.Row}>
                            <View style={styles.Box}>
                              <Text style={styles.Lable}>
                                <Image src={logo} />
                              </Text>
                              <Text style={styles.Value}>Flight No: {traveler?.flightNumber}</Text>
                            </View>
                            <View style={styles.Box}>
                              <Text style={styles.Lable}> origin:</Text>
                              <View style={styles.Box}>
                                <Text style={styles.Value}>{getDate(traveler?.departureDateTime)}</Text>
                                <Text style={styles.Value}>{traveler?.departureAirport?.locationCode}</Text>
                                <Text style={styles.Value}>{traveler?.departureAirport?.locationName}</Text>
                              </View>
                            </View>
                            <View style={styles.Box}>
                              <Text style={styles.Lable}>destination: </Text>
                              <View style={styles.Box}>
                                <Text style={styles.Value}>{getDate(traveler?.arrivalDateTime)}</Text>
                                <Text style={styles.Value}>{traveler?.arrivalAirport?.locationCode}</Text>
                                <Text style={styles.Value}>{traveler?.arrivalAirport?.locationName}</Text>
                              </View>
                            </View>
                            <View style={styles.Box}>
                              <Text style={styles.Lable}>flight class: </Text>
                              <Text style={styles.Value}>
                                {' '}
                                {traveler.resBookDesigCode === 'Z1' ? 'Business' : 'economy'}
                              </Text>
                            </View>
                          </View>
                        </View>
                      </View>
                    </>
                  );
                }
              )}
            </View>
          </>
        )}
        {ticketData?.bookData?.priceInfo && (
          <>
            <Text style={styles.Title}>price info:</Text>
            <View style={styles.Card}>
              <View style={styles.BoxWrapper}>
                <View style={styles.Row}>
                  <View style={styles.Box}>
                    <Text style={styles.Lable}>base price: </Text>
                    <Text style={styles.Value}>{priceFormat(Number(ptcBaceFar()))} IRR</Text>
                  </View>
                  <View style={styles.Box}>
                    <Text style={styles.Lable}>tax:</Text>
                    <Text style={styles.Value}> {priceFormat(Number(ptcTotalFar()) - Number(ptcBaceFar()))} IRR</Text>
                  </View>
                  <View style={styles.Box}>
                    <Text style={styles.Lable}>total price: </Text>
                    <Text style={styles.Value}>{priceFormat(Number(ptcTotalFar()))} IRR</Text>
                  </View>
                </View>
              </View>
            </View>
          </>
        )}
        {/* </View> */}
      </Page>
    </Document>
  );
};

export default Invoice;
